const personTypes = [
  { key: "Natural", value: "Persona Natural" },
  { key: "Jurídica", value: "Persona Jurídica" },
];

const idTypes = {
  natural: [
    { key: "Cédula de ciudadanía", value: "36" },
    { key: "Cédula de extranjería", value: "33" },
    { key: "Pasaporte", value: "40" },
    { key: "Tarjeta de Identidad", value: "34" },
    { key: "Registro Civil", value: "35" },
    { key: "Carné Diplomático", value: "44" },
    { key: "Documento Nacional de Identidad", value: "38" },
    { key: "PECP", value: "47" },
    { key: "Permiso Especial de Permanencia", value: "46" },
    { key: "Permiso por proteccion temporal", value: "48" },
  ],
  juridica: [
    { key: "NIT", value: "37" },
    { key: "NIT Extranjero", value: "45" },
  ],
};

const allIdTypes = {
  36: "Cédula de ciudadanía",
  33: "Cédula de extranjería",
  40: "Pasaporte",
  34: "Cédula de extranjería",
  35: "Cédula de extranjería",
  47: "PECP",
  44: "Carné Diplomático",
  46: "Permiso Especial de Permanencia",
  37: "NIT",
  38: "Documento Nacional de Identidad",
  45: "NIT Extranjero",
  48: "Permiso por proteccion temporal"
};

export { personTypes, idTypes, allIdTypes };
